import React from 'react'
import SearchField from '../formControls/SearchField'

export type MediaLibrarySearchFilterProps = {
	searchText?: string
	onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	onClearSearchClick?: () => void
	searchFilters?: React.ReactNode
}

const MediaLibrarySearchFilter = ({
	searchText,
	onSearchChange,
	onClearSearchClick,
	searchFilters,
}: MediaLibrarySearchFilterProps) => {
	if (!onSearchChange && !searchFilters) return null

	return (
		<div>
			{onSearchChange && (
				<SearchField
					initialSearchText={searchText}
					onSearchChange={onSearchChange}
					onClearSearchClick={onClearSearchClick}
				/>
			)}
			{searchFilters}
		</div>
	)
}

export default MediaLibrarySearchFilter
